// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './register.css';
// import userIcon from '../images/profile.png';

// const Register = () => {
//   const [formData, setFormData] = useState({
//     username: '',
//     password: '',
//     confirmPassword: '',
//     email: '',
//     // companyName: '',
//     // companyAddress: '',
//     // companyContactNo: ''
//     companyId:1
//   });
//   const [passwordError, setPasswordError] = useState('');
//   const [userError, setUserError] = useState('');
//   const [companyError, setCompanyError] = useState('');
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.password !== formData.confirmPassword) {
//       setPasswordError('Passwords do not match');
//       return;
//     }

//     try {
    
//       // const companyResponse = await fetch(`https://invoice.dockyardsoftware.com/api/Company`, {
//       //   method: 'POST',
//       //   headers: {
//       //     'Content-Type': 'application/json'
//       //   },

//       const companyResponse = await fetch('https://invoice.dockyardsoftware.com/api/Company', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         // body: JSON.stringify({
//         //   companyName: formData.companyName,
//         //   companyAddress: formData.companyAddress,
//         //   companyContactNumber: formData.companyContactNo
//         // })
//       });

      

//       if (!companyResponse.ok) {
//         const errorText = await companyResponse.text(); 
//         setCompanyError(`Failed to create company: ${errorText}`);
//         throw new Error(`Failed to create company: ${errorText}`);
//       }

//       const companyData = await companyResponse.json();

//       const companyId = companyData.companyId;

     
//       // const userResponse = await fetch(`https://invoice.dockyardsoftware.com/api/User`, {
//       //   method: 'POST',
//       //   headers: {
//       //     'Content-Type': 'application/json'
//       //   },
//       const userResponse = await fetch(`https://invoice.dockyardsoftware.com/api/User`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
      
//         body: JSON.stringify({
//           userName: formData.username,
//           password: formData.password,
//           companyId: companyId,
//           userEmail: formData.email
//         })
//       });


//       if (!userResponse.ok) {
//         const errorText = await userResponse.text();
//         setUserError(`Failed to register user: ${errorText}`);
//         throw new Error(`Failed to register user: ${errorText}`);
//       }

      
//       console.log('Registration successful:', formData);
//       navigate('/login');
//     } catch (error) {
//       console.error('Registration error:', error);
   
//     }
//   };

  
//       console.log(formData);

//   return (
//     <div className="register-container">
//       <div className="register-box">
//         <img src={userIcon} alt="User Icon" className="user-icon" />
//         <h2>Register</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label>User Name</label>
//             <input type="text" name="username" value={formData.username} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Email</label>
//             <input type="email" name="email" value={formData.email} onChange={handleChange} required />
//           </div>
//           {/* <div className="form-group">
//             <label>Company Name</label>
//             <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Company Address</label>
//             <input type="text" name="companyAddress" value={formData.companyAddress} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Company Contact No.</label>
//             <input type="tel" name="companyContactNo" value={formData.companyContactNo} onChange={handleChange} required />
//           </div> */}
//           <div className="form-group">
//             <label>Password</label>
//             <input type="password" name="password" value={formData.password} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Confirm Password</label>
//             <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required />
//             {passwordError && <p className="error-message">{passwordError}</p>}
//           </div>
//           <button type="submit" className="btn">Register</button>
//         </form>
//         <p>Already have an account? <a href="/login">Login here</a></p>
//       </div>
//     </div>
//   );
// };

// export default Register;



// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import './register.css';
// import userIcon from '../images/profile.png';

// const Register = () => {
//   const [formData, setFormData] = useState({
//     username: '',
//     password: '',
//     confirmPassword: '',
//     email: '',
//     companyName: '',
//     companyAddress: '',
//     companyContactNo: ''
//   });
//   const [passwordError, setPasswordError] = useState('');
//   const [userError, setUserError] = useState('');
//   const [companyError, setCompanyError] = useState('');
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.password !== formData.confirmPassword) {
//       setPasswordError('Passwords do not match');
//       return;
//     }

//     try {
//       // Step 1: Post the Company data
//       const companyResponse = await fetch('https://invoice.dockyardsoftware.com/api/Company', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           companyName: formData.companyName,
//           companyAddress: formData.companyAddress,
//           companyContactNumber: formData.companyContactNo
//         })
//       });

      

//       if (!companyResponse.ok) {
//         const errorText = await companyResponse.text(); 
//         setCompanyError(`Failed to create company: ${errorText}`);
//         throw new Error(`Failed to create company: ${errorText}`);
//       }

//       const companyData = await companyResponse.json();

//       const companyId = companyData.companyId;

     
//       const userResponse = await fetch('https://invoice.dockyardsoftware.com/api/User', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify({
//           userName: formData.username,
//           password: formData.password,
//           companyId: companyId,
//           userEmail: formData.email
//         })
//       });

//       if (!userResponse.ok) {
//         const errorText = await userResponse.text();
//         setUserError(`Failed to register user: ${errorText}`);
//         throw new Error(`Failed to register user: ${errorText}`);
//       }

      
//       console.log('Registration successful:', formData);
//       navigate('/login');
//     } catch (error) {
//       console.error('Registration error:', error);
   
//     }
//   };

//   return (
//     <div className="register-container">
//       <div className="register-box">
//         <img src={userIcon} alt="User Icon" className="user-icon" />
//         <h2>Register</h2>
//         <form onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label>User Name</label>
//             <input type="text" name="username" value={formData.username} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Email</label>
//             <input type="email" name="email" value={formData.email} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Company Name</label>
//             <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Company Address</label>
//             <input type="text" name="companyAddress" value={formData.companyAddress} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Company Contact No.</label>
//             <input type="tel" name="companyContactNo" value={formData.companyContactNo} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Password</label>
//             <input type="password" name="password" value={formData.password} onChange={handleChange} required />
//           </div>
//           <div className="form-group">
//             <label>Confirm Password</label>
//             <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required />
//             {passwordError && <p className="error-message">{passwordError}</p>}
//           </div>
//           <button type="submit" className="btn">Register</button>
//         </form>
//         <p>Already have an account? <a href="/login">Login here</a></p>
//       </div>
//     </div>
//   );
// };

// export default Register;


import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import './register.css';
import userIcon from '../images/profile.png';
import bg from '../images/bg.png';
import ParticleBackground from './ParticlesBackground';

//Same styles aplly for this register also
// const ParticleBackground = () => {
//   const Particlesinit = async (main) => {
//     await loadFull(main);
//   };
  
//   return (
//     <Particles
//       init={Particlesinit}
//       options={{
//         particles: {
//           number: {
//             value: 80,
//             density: {
//               enable: true,
//               value_area: 1200,
//             },
//           },
//           color: {
//             value: '#ffffff',
//           },
//           shape: {
//             type: 'circle',
//             stroke: {
//               width: 0,
//               color: '#000000',
//             },
//             polygon: {
//               nb_sides: 5,
//             },
//             image: {
//               src: 'img/github.svg',
//               width: 100,
//               height: 100,
//             },
//           },
//           opacity: {
//             value: 0.5,
//             random: false,
//             anim: {
//               enable: false,
//               speed: 1,
//               opacity_min: 0.1,
//               sync: false,
//             },
//           },
//           size: {
//             value: 3,
//             random: true,
//             anim: {
//               enable: false,
//               speed: 40,
//               size_min: 0.1,
//               sync: false,
//             },
//           },
//           line_linked: {
//             enable: true,
//             distance: 150,
//             color: '#ffffff',
//             opacity: 0.4,
//             width: 1,
//           },
//           move: {
//             enable: true,
//             speed: 3,
//             direction: 'none',
//             random: false,
//             straight: true,
//             out_mode: 'out',
//             bounce: false,
//             attract: {
//               enable: false,
//               rotateX: 600,
//               rotateY: 1200,
//             },
//           },
//         },
//         interactivity: {
//           detect_on: 'canvas',
//           events: {
//             onhover: {
//               enable: true,
//               mode: 'repulse',
//             },
//             onclick: {
//               enable: true,
//               mode: 'push',
//             },
//             resize: true,
//           },
//           modes: {
//             grab: {
//               distance: 400,
//               line_linked: {
//                 opacity: 1,
//               },
//             },
//             bubble: {
//               distance: 400,
//               size: 40,
//               duration: 2,
//               opacity: 8,
//               speed: 3,
//             },
//             repulse: {
//               distance: 200,
//               duration: 0.4,
//             },
//             push: {
//               particles_nb: 4,
//             },
//             remove: {
//               particles_nb: 2,
//             },
//           },
//         },
//         retina_detect: true,
//         background: {
//           color: 'transparent',
//         },
//       }}
//     />
//   );
// };

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    email: '',
    companyName: '',
    companyAddress: '',
    companyContactNo: ''
  });
  const [passwordError, setPasswordError] = useState('');
  const [userError, setUserError] = useState('');
  const [companyError, setCompanyError] = useState('');
  const [contactError, setContactError] = useState(''); // ✅ added back
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "companyContactNo") {
      if (/^\d{0,10}$/.test(value)) {  // ✅ allow only digits, max 10
        setFormData({ ...formData, [name]: value });
        setContactError('');
      } else {
        setContactError('');
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setPasswordError('Passwords do not match');
      return;
    }

    // ✅ exactly 10 digits validation
    if (!/^\d{10}$/.test(formData.companyContactNo)) {
      setContactError('Company contact number must be exactly 10 digits');
      return;
    }

    try {
      const companyResponse = await fetch('https://invoice.dockyardsoftware.com/api/Company', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          companyName: formData.companyName,
          companyAddress: formData.companyAddress,
          companyContactNumber: formData.companyContactNo
        })
      });

      if (!companyResponse.ok) {
        const errorText = await companyResponse.text(); 
        setCompanyError(`Failed to create company: ${errorText}`);
        throw new Error(`Failed to create company: ${errorText}`);
      }

      const companyData = await companyResponse.json();
      const companyId = companyData.companyId;

      const userResponse = await fetch('https://invoice.dockyardsoftware.com/api/User', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          userName: formData.username,
          password: formData.password,
          companyId: companyId,
          userEmail: formData.email
        })
      });

      if (!userResponse.ok) {
        const errorText = await userResponse.text();
        setUserError(`Failed to register user: ${errorText}`);
        throw new Error(`Failed to register user: ${errorText}`);
      }

      console.log('Registration successful:', formData);
      navigate('/login');
    } catch (error) {
      console.error('Registration error:', error);
    }
  };

  return (
    <div className="register-page" style={{ backgroundImage: `url(${bg})` }}>
      <div className="particles-background">
        <ParticleBackground />
      </div>
      <div className="register-container">
        <div className="register-box">
          <img src={userIcon} alt="User Icon" className="user-icon" />
          <h2>Register</h2>
          <form onSubmit={handleSubmit} className="register-form">
            <div className="form-row">
              <div className="form-group">
                <label><strong>User Name</strong></label>
                <input type="text" name="username" value={formData.username} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label><strong>Email</strong></label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label><strong>Company Name</strong></label>
                <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label><strong>Company Contact No.</strong></label>
                <input type="tel" name="companyContactNo" value={formData.companyContactNo} onChange={handleChange} required />
                {contactError && <p className="error-message">{contactError}</p>} {/* ✅ show error */}
              </div>
            </div>
            
            <div className="form-group full-width">
              <label><strong>Company Address</strong></label>
              <input type="text" name="companyAddress" value={formData.companyAddress} onChange={handleChange} required />
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label><strong>Password</strong></label>
                <input type="password" name="password" value={formData.password} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label><strong>Confirm Password</strong></label>
                <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required />
              </div>
            </div>
            
            {passwordError && <p className="error-message">{passwordError}</p>}
            {userError && <p className="error-message">{userError}</p>}
            {companyError && <p className="error-message">{companyError}</p>}
            
            <button type="submit" className="btn">Register</button>
          </form>
          <p className="login-link">Already have an account? <a href="/login">Login here</a></p>
        </div>
      </div>
    </div>
  );
};

export default Register;